module.exports = __webpack_public_path__ + "static/media/loadingnew.cee2ff69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/loadingnew.svg
// module id = 33
// module chunks = 0